//dependencias
import React, { Component } from 'react';

//componentes
import PlanificacionAction from './planificacion'

class Index extends Component {

    render(){
        return(
            <div>
                <PlanificacionAction />
            </div>
        );
    }

}
export default Index;